import { Text, View } from '@react-pdf/renderer';
import React from 'react';

export interface ActualAcresLabelProps {
  label: string;
}

const ActualAcresLabel = ({ label }: ActualAcresLabelProps) => {
  return (
    <View style={{ marginTop: 22, borderTop: '1px solid #C2C7D0' }}>
      <Text
        style={{
          fontFamily: 'Noto Sans',
          fontWeight: 400,
          paddingBottom: 8,
          fontSize: 9,
          textTransform: 'uppercase',
          color: '#4D5165'
        }}
      >
        {label}
      </Text>
    </View>
  );
};

export default ActualAcresLabel;
